export default __webpack_public_path__ + "static/media/certificado.9aba3103.jpg";